module.exports = __webpack_public_path__ + "static/media/search.e08a3913.svg";